<template>
  <div
    class="menu-burger"
    :class="`menu-burger--${ overlap }`"
  >
    <div
      class="menu-burger__content"
      @click="toggleMenu"
    >
      <div class="menu-burger__line"/>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    overlap: {
      type: String,
      default: 'hero'
    }
  },
  methods: {
    ...mapMutations(['toggleMenu'])
  }
}
</script>

<style lang="scss" scoped>
  .menu-burger {
    cursor: pointer;
    position: relative;
    z-index: 10;
    transform: translateX( 50% );

    @each $breakpoint-name, $space in $grid-space-around {
      @include media-up($breakpoint-name) {
        right: #{$space/2};
      }
    }

    &,
    &__content {
      width: $burger-width;
      height: $burger-line-height * 3 + $burger-line-offset * 2;
    }

    &__content {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      pointer-events: auto;
      &:hover {
        opacity: .7
      }
    }
    &__line {
      top: 50%;
      display: block;

      &,
      &:after,
      &:before {
          position: absolute;
          width: $burger-width;
          height: $burger-line-height;
          transition: background-color .15s, transform .15s;

          background-color: #000;
          @include media-up(md) {
            background-color: #fff;
          }
      }
      & {
        transition: background-color .15s, transform 75ms cubic-bezier(.55,.055,.675,.19);
      }

      &:after,
      &:before {
          display: block;
          content: "";
      }

      &:before {
          top: -$burger-line-offset - $burger-line-height;
          transition: top 75ms ease .12s, opacity 75ms ease, background-color .15s;
      }

      &:after {
          bottom: -$burger-line-offset - $burger-line-height;
          transition: bottom 75ms ease .12s,
                      transform 75ms cubic-bezier(.55,.055,.675,.19),
                      background-color .15s;
      }
    }

    &--about &__line {
      @include media-down(md) {
        &,
        &:after,
        &:before {
          background-color: #fff;
        }
      }
    }
    &--projects &__line,
    &--manifest &__line,
    &--contact &__line {
      @include media-up(md) {
        &,
        &:after,
        &:before {
          background-color: #000;
        }
      }
    }

    .active-menu & {
      &__line {
        transition-delay: .12s;
        transition-timing-function: cubic-bezier(.215,.61,.355,1);
        transform: rotate(45deg);
        &,
        &:after,
        &:before {
          background-color: #fff;
        }
        &:before {
            top: 0;
            transition: top 75ms ease,opacity 75ms ease .12s;
            opacity: 0;
        }

        &:after {
            bottom: 0;
            transition: bottom 75ms ease,transform 75ms cubic-bezier(.215,.61,.355,1) .12s;
            transform: rotate(-90deg);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Burger.vue